<procure-entity-badge
  [label]="label()"
  [link]="link()"
  [copyable]="false"
  (click)="openEntity()"
/>
